import React, { useEffect, useState } from 'react'
interface IProps {
  closeModal: () => void
}
const ShareFormSettingModal: React.FC<IProps> = ({ closeModal }) => {
  const [selectedAccess, setSelectedAccess] = useState<string | null>(null)
  const handleAccessClick = (accessType: string) => {
    setSelectedAccess(accessType === selectedAccess ? null : accessType)
  }
  useEffect(() => {
    // Set the default access to 'public' when the component mounts
    setSelectedAccess('public')
  }, [])
  return (
    <div>
      <div className='card w-450px h-450px mb-4 position-relative'>
        {/* Close button */}
        <button
          type='button'
          className='btn-close position-absolute top-0 end-0 m-n4 rounded-circle'
          aria-label='Close'
          onClick={closeModal}
          style={{
            backgroundColor: 'rgba(218,222,243)',
            height: '25px',
            width: '25px',
            color: 'rgba(52,60,106'
          }}
        ></button>
        <div className='d-flex flex-column justify-content-between mx-0 px-0 mb-2'>
          <div className='d-flex justify-content-between align-items-center px-3 py-2'>
            <h2 className='mb-0'>Settings</h2>
          </div>
          <hr className='mt-4' style={{ width: '100%', borderTop: '1px solid #000' }} />
          {/* Access Setting Section */}
          <div className='section'>
            <h3 className='section-title mt-4 mb-4'>Access Settings</h3>
            <ul className='list-group'>
              {/* Private Form */}
              <li
                className={`list-group-item d-flex justify-content-between align-items-center ${
                  selectedAccess === 'private' ? 'active' : ''
                }`}
                onClick={() => handleAccessClick('private')}
                style={{
                  background: selectedAccess === 'private' ? 'rgb(237, 242, 255)' : '',
                  borderColor: selectedAccess === 'private' ? 'rgba(66, 119, 255, 0.53)' : ''
                }}
              >
                <div className='d-flex align-items-center'>
                  <span className='badge'>
                    <i
                      className='bi bi-lock-fill'
                      style={{
                        fontSize: '30px',
                        color: selectedAccess === 'private' ? 'rgb(66, 119, 255)' : ''
                      }}
                    ></i>
                  </span>
                  <div className='ms-3'>
                    <h5 className='mt-5 mb-1'>Private Form</h5>
                    <p className='mb-1'>Only available to invited people.</p>
                  </div>
                </div>
                {selectedAccess === 'private' && (
                  <span className='badge' style={{ color: 'rgb(66, 119, 255)' }}>
                    <i className='bi bi-check-circle-fill' style={{ fontSize: '25px' }}></i>
                  </span>
                )}
              </li>
            </ul>
          </div>
          {/* Add a gap between cards */}
          <div style={{ height: '20px' }}></div>
          {/* Access Setting Section */}
          <div className='section'>
            <ul className='list-group'>
              {/* Public Form */}
              <li
                className={`list-group-item d-flex justify-content-between align-items-center ${
                  selectedAccess === 'public' ? 'active' : ''
                }`}
                onClick={() => handleAccessClick('public')}
                style={{
                  background: selectedAccess === 'public' ? 'rgb(237, 254, 209)' : '',
                  borderColor: selectedAccess === 'public' ? 'rgb(100, 178, 0)' : ''
                }}
              >
                <div className='d-flex align-items-center'>
                  <span className='badge'>
                    <i
                      className='bi bi-unlock-fill'
                      style={{
                        fontSize: '30px',
                        color: selectedAccess === 'public' ? 'rgb(82, 147, 0)' : ''
                      }}
                    ></i>
                  </span>
                  <div className='ms-3'>
                    <h5 className='mt-5 mb-1'>Public Form</h5>
                    <p className='mb-1'>Available to anyone.</p>
                  </div>
                </div>
                {selectedAccess === 'public' && (
                  <span className='badge' style={{ color: 'rgb(82, 147, 0)' }}>
                    <i className='bi bi-check-circle-fill' style={{ fontSize: '25px' }}></i>
                  </span>
                )}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ShareFormSettingModal
